import * as React from 'react';
import { ArticleHeading1, ArticleHeading2, ArticleHeading3, ArticleHeading6, Body2 } from '@cian/ui-kit';
import { ConditionalWrapper } from '@cian/conditional-component';
import cn from 'clsx';
import { head, isNil, tail } from 'ramda';

import * as styles from './styles.css';

export enum EPromoPriceSize {
  XS = 'xs',
  M = 'm',
}

export interface IPromoPriceProps {
  price: string;
  oldPrice: string;
  promoPriceText?: string;
  termsOfPromotion?: string | null;
  size?: EPromoPriceSize;
}

export const PromoPrice: React.FC<IPromoPriceProps> = props => {
  const { oldPrice, promoPriceText, price, size = EPromoPriceSize.M, termsOfPromotion } = props;
  const isSizeM = size === EPromoPriceSize.M;

  /** Первое слово должно содержать ссылку на акцию **/
  const [firstWord, promoText] = React.useMemo(() => {
    if (isNil(promoPriceText)) {
      return [];
    }

    const words = promoPriceText.split(' ');

    return [head(words), tail(words).join(' ')];
  }, [promoPriceText]);

  return (
    <div className={cn(styles['container'], { [styles['size-medium']]: isSizeM })} data-testid="promo-price">
      <div className={styles['price']}>
        <ConditionalWrapper
          if={size === EPromoPriceSize.M}
          ThenComponent={ArticleHeading1}
          ElseComponent={ArticleHeading3}
          color="theme-white"
        >
          {price}
        </ConditionalWrapper>
        <div className={styles['price-old']}>
          <ConditionalWrapper
            if={size === EPromoPriceSize.M}
            ThenComponent={ArticleHeading2}
            ElseComponent={ArticleHeading6}
            color="theme-white"
          >
            {oldPrice}
          </ConditionalWrapper>
        </div>
      </div>
      <div className={styles['promo-text']}>
        {termsOfPromotion ? (
          <Body2 color="text-inverted-default">
            <a className={styles['promo-link']} href={termsOfPromotion} target="_blank" rel="noreferrer">
              {firstWord}
            </a>{' '}
            <span>{promoText}</span>
          </Body2>
        ) : (
          <Body2 color="text-inverted-default">{promoPriceText}</Body2>
        )}
      </div>
    </div>
  );
};

PromoPrice.displayName = 'PromoPrice';
